module.exports = __webpack_public_path__ + "img/ai.d6af3a0f.svg";